








import Vue from 'vue';

import { toggleFilterValue } from '../store/actions';
import { IFilterValue } from '../store/state';

interface IFilterPillProps extends IFilterValue {
	filterName: string;
}

interface IFilterPillMethods {
	deselect(): void;
}

export default Vue.extend<{}, IFilterPillMethods, {}, IFilterPillProps>({
	props: {
		name: String,
		value: String,
		selected: Boolean,
		filterName: String,
		filterSelectName: String
	},
	methods: {
		deselect(){
			this.$store.dispatch(toggleFilterValue({
				name: this.filterName,
				value: {
					name: this.name,
					value: this.value,
					selected: this.selected
				}
			}));
		}
	}
})
